export const PostbackActionTypes = {
  GET_POSTBACK: undefined,
  GET_POSTBACK_SUCCESS: undefined,

  SET_BRAND_TO_POSTBACK_FILTER: undefined,
  SET_EVENT_TYPE_TO_POSTBACK_FILTER: undefined,
  SET_ENABLED_TO_POSTBACK_FILTER: undefined,
};
